const COOKIES = {
  IS_USER_LOGGED: 'is_user_logged',
  OFFERS_VIEW_MODE: 'offers_view_mode',
  WEBVIEW_APP_THEME_FALLBACK: 'webview_app_theme',
  WEBVIEW_AUTH_TOKEN_FALLBACK: 'webview_auth_token',
};

export default COOKIES;
